import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInvoiceRegularDiagonalIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19.4 1.4q-.3-.6-1-.7-.5 0-1 .3L1 17.4q-.5.5-.3 1 0 .7.7 1L4 20.6l1 2.3q.2.6.7.7l2 .7.7 2q0 .5.7.7l2.3 1 1.2 2.6q.3.6 1 .7.5.2 1-.3L31 14.6q.4-.5.3-1 0-.7-.7-1L28 11.4l-1-2.3q-.2-.6-.7-.7l-2-.7-.7-2q0-.5-.6-.7l-2.4-1zM3.9 17.9l14-14 .7 1.6q.2.4.6.6l2.3 1 .7 2q.2.5.8.7l2 .7 1 2.3q.1.5.5.6l1.6.7-14 14-.7-1.6q-.2-.4-.6-.6l-2.3-1-.7-2q-.2-.5-.8-.7l-2-.7-1-2.3q-.1-.4-.5-.6zm13.8-8.7A1.2 1.2 0 1 0 16 11l5 5.1a1.2 1.2 0 1 0 1.8-1.7zM10.9 16a1.2 1.2 0 1 0-1.7 1.7l5.1 5a1.2 1.2 0 1 0 1.7-1.6zm1.7-3.4q-.7.8 0 1.7l5.1 5a1.2 1.2 0 1 0 1.7-1.6l-5.1-5q-.8-.9-1.7 0" })
});
export default SvgInvoiceRegularDiagonalIcon;
